import type { AgentBehavior, AiMode } from "./aiTypes.ts";

/**
 * The ONE place that decides where a run executes. UI components, the server and the agent all consume this.
 *
 *   Chat                → Host, read-only
 *   Agent Interactive   → Host, read/write
 *   Agent Autonomous    → Worktree, read/write (never falls back to Host)
 *
 * Legacy modes keep their compatibility mapping: ask|plan → Chat, edit|agent → Agent Interactive.
 */
export interface ExecutionRoute {
  environment: "host" | "worktree";
  access: "read-only" | "read-write";
}

export function resolveExecutionRoute(input: { mode: AiMode; behavior?: AgentBehavior | undefined }): ExecutionRoute {
  switch (input.mode) {
    case "chat":
    case "ask":
    case "plan":
      return { environment: "host", access: "read-only" };
    case "edit":
      return { environment: "host", access: "read-write" };
    case "agent":
      return input.behavior === "autonomous"
        ? { environment: "worktree", access: "read-write" }
        : { environment: "host", access: "read-write" };
  }
}

/** A user-safe reason when the requested environment does not satisfy the route, otherwise null. */
export function executionRouteViolation(route: ExecutionRoute, environmentId: string | undefined): string | null {
  if (route.environment === "worktree" && !environmentId) {
    return "Agent Autonomous always runs in an isolated Git Worktree and never on the Host. No Worktree is available, so nothing was started and your project was not touched.";
  }
  return null;
}
